import type { ButtonBackground, ButtonColor, ButtonSize, ButtonStyle } from '@tranquility-ai/theme-components/button';

/**
 * Presentation prev/next slide controls — theme `lg` icon-only outline buttons on
 * the inverse (dark) presentation surface. Do not add className overrides.
 */
export const presentationNavIconButtonProps = {
  iconOnly: true,
  size: 'lg' as ButtonSize,
  style: 'outline' as ButtonStyle,
  color: 'light' as ButtonColor,
  background: 'inverse' as ButtonBackground,
} as const;
